import { render } from "./FinanceInfoComponent.vue?vue&type=template&id=c54aaf92&scoped=true&ts=true"
import script from "./FinanceInfoComponent.vue?vue&type=script&lang=ts"
export * from "./FinanceInfoComponent.vue?vue&type=script&lang=ts"

import "./FinanceInfoComponent.vue?vue&type=style&index=0&id=c54aaf92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54aaf92"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSelect,QDialog,QTooltip,QIcon,QBtn});
